import * as types from "../actions/action-types";

const initialState = {
	fetchingSearchHistory: false,
	searchHistory: []
};

const reducer = (state = initialState, action = {}) => {
	switch (action.type) {
		/** ACTION TYPES FOR SEARCH HISTORY START */
		case `${types.FETCH_SEARCH_HISTORY}_PENDING`:
			return Object.assign({}, state, {
				fetchingSearchHistory: true
			});

		case `${types.FETCH_SEARCH_HISTORY}_FULFILLED`:
			return Object.assign({}, state, {
				fetchingSearchHistory: false,
				searchHistory: action.payload.data.Details
			});

		case `${types.FETCH_SEARCH_HISTORY}_REJECTED`:
			return {
				isRejected: true,
				error: "Fetch Search History Failed"
			};
		/** ACTION TYPES FOR SAVE_SEARCH_TO_HISTORY START */
		case `${types.SAVE_SEARCH_TO_HISTORY}_PENDING`: {
			let searchHistory = state.searchHistory.slice();
			if(!searchHistory.find((search)=> search.SearchTerm === action.meta))
			{
				searchHistory.pop();
				searchHistory.unshift({ SearchTerm: action.meta });
			}
			//remove duplicates
			//searchHistory = searchHistory.filter((thing, index, self) => self.findIndex((t) => {return t.SearchTerm === thing.SearchTerm; }) === index)
			return Object.assign({}, state, {
				searchHistory: searchHistory
			});
		}

		case `${types.SAVE_SEARCH_TO_HISTORY}_REJECTED`:
			return {
				isRejected: true,
				error: "Save Search History Failed"
			};

		default:
			return state;
	}
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearch/reducer/SearchHistoryReducer.js